import React, { Component } from "react";
import {
  InputGroup,
  InputGroupAddon,
  Input,
  Row,
  Col,
  Button,
  Table
} from "reactstrap";

import Collapsible from 'react-collapsible';
import { reduxForm } from 'redux-form'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import Pagination from "react-js-pagination";
import * as congNoConstant from './constants'
import * as congNoAction from './actions'
import { storedb } from '../client/storedb'
import DisplayRecordText from "../controls/_DisplayRecordText"
import { currentDate } from "../../lib/common";
import CheckboxTreeList from "../controls/_CheckboxTreeList";

class CongNo extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    congNoListRequest: PropTypes.func,
    congNoKhoXuatRequest: PropTypes.func,
    reportExportXlsRequest: PropTypes.func,
    congNo: PropTypes.shape({
      list: PropTypes.array,
      item: PropTypes.object,
      type: PropTypes.string,
      listRequesting: PropTypes.bool,
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    }),
  }
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      store_id: dbContext.getStoreId(),
      tuNgay: currentDate().startOf('month'),
      denNgay: currentDate(),
      item: {},
      list: [],
      total_record: 0,
      tong_soLuong: 0,
      page: 1,
      per_page: 20,
      multipleValueKhoXuat: [],
      listKhoXuat: [],
      loaiCongNo: 1,
      maNhanVien: "",
      keyword: ""
    };
    this.handleDateChange = this.handleDateChange.bind(this);
  }

  viewCongNoKh = (e, maKH) => {
    e.preventDefault()
    const url = `/congnokh/${this.state.tuNgay.format('YYYYMMDD')}/${this.state.denNgay.format('YYYYMMDD')}/${maKH}`
    this.props.history.push(url);
  };
  handleDateChange(name, e, value) {
    switch (name) {
      case "tuNgay":
        this.setState({ tuNgay: e });
        break;
      case "denNgay":
        this.setState({ denNgay: e });
        break;
    }
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      case "maNhanVien":
          this.setState({ maNhanVien: e.target.value });
        break;
      default:
        break;
    }
  }
  handleSelectChange = (name, selectedOption) => {
    switch (name) {
      case "loaiCongNo":
        this.setState({ loaiCongNo: selectedOption.target.value })
        break;
      default:
        break;
    }
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }

  onHandleRemoveKhoXuat = () => {
    this.setState({multipleValueKhoXuat: []})
  }
  onHandleChoiceKhoXuat = (nodesChecked) => {
    var multipleValue = [];
    nodesChecked.forEach(function (item) {
      multipleValue.push(item.value);
    });
    this.setState({multipleValueKhoXuat: multipleValue})
  }

  fetchList(page) {
    const { congNoListRequest } = this.props

    var requestData = {
      storeId: this.state.store_id,
      khoIds: this.state.multipleValueKhoXuat,
      maNhanVien: this.state.maNhanVien,
      loai: this.state.loaiCongNo,
      fromDate: this.state.tuNgay ? this.state.tuNgay.format('YYYYMMDD') : '',
      toDate: this.state.denNgay ? this.state.denNgay.format('YYYYMMDD') : '',
      keyword: this.state.keyword,
      page: page || this.state.page,
      per_page: this.state.per_page
    }
    return congNoListRequest(requestData)
  }
  exportXls = () => {
    const { reportExportXlsRequest } = this.props

    var requestData = {
      storeId: this.state.store_id,
      khoIds: this.state.multipleValueKhoXuat,
      maNhanVien: this.state.maNhanVien,
      loai: this.state.loaiCongNo,
      fromDate: this.state.tuNgay ? this.state.tuNgay.format('YYYYMMDD') : '',
      toDate: this.state.denNgay ? this.state.denNgay.format('YYYYMMDD') : '',
      keyword: this.state.keyword,
      page: 1,
      per_page: 5000
    };
    return reportExportXlsRequest(requestData);
  }
  search = () => {
    if (this.props.congNo.listRequesting) {
      return false;
    }
    return this.setState({ page: 1 }, () => {
      this.fetchList(1);
    });
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  fetchKhoXuat = () => {
    const { congNoKhoXuatRequest } = this.props
    var requestData = {
      store_id: this.state.store_id
    };
    return congNoKhoXuatRequest(requestData);
  }
  componentDidMount() {
    this.fetchKhoXuat();
    this.fetchList(1);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.congNo.type == congNoConstant.CONG_NO_KHOXUAT_SUCCESS) {
      let { list } = nextProps.congNo;
      this.setState({
        listKhoXuat: list
      });
    }
    else if (nextProps.congNo.type == congNoConstant.CONG_NO_LIST_SUCCESS) {
      let { list, item } = nextProps.congNo;
      this.setState(
        {
          page: item.page,
          per_page: item.per_page,
          total_record: item.total_record,
          totalRecord: item.total_record[0].countRecorde || 0,
          list: list
        }
      )
    }
    else if (nextProps.congNo.type == congNoConstant.CONG_NO_EXPORT_XLS_SUCCESS) {
      let { item } = nextProps.congNo;
      var dataFile = new Blob([item], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExportCongNo';
      var fileName = "danhsachcongno.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExportCongNo";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
        link.remove();
      }
    }
  }
  render() {
    const { 
      list, 
      listKhoXuat, 
    } = this.state

    const {
      handleSubmit,
      congNo: {
        listRequesting
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm..." overflowWhenOpen="inherit" open={true}>
              <Row>
                <Col sm="3" className="mb-2 pr-0">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend" autoComplete="off">Từ</InputGroupAddon>
                    <DatePicker name="tuNgay" autoComplete="off" placeholder="Từ ngày" selected={this.state.tuNgay} onChange={this.handleDateChange.bind(this, "tuNgay")} required className={"form-control w-100px"} />
                  </InputGroup>
                </Col>
                <Col sm="3" className="mb-2 pr-0">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend" autoComplete="off" >Đến</InputGroupAddon>
                    <DatePicker name="denNgay" autoComplete="off" placeholder="đến ngày" selected={this.state.denNgay} onChange={this.handleDateChange.bind(this, "denNgay")} required className={"form-control w-100px"} />
                  </InputGroup>
                </Col>
                <Col sm="3" className="mb-2">
                  <InputGroup size="md">
                    <select className="form-control" value={this.state.loaiCongNo} onChange={this.handleSelectChange.bind(this, "loaiCongNo")}>
                      <option value={1}>Công nợ phải thu</option>
                      <option value={2}>Công nợ phải trả</option>
                    </select>
                  </InputGroup>
                </Col>
                <Col sm="3" className="mb-2">
                  <InputGroup size="md">
                    <Input name="keyword" placeholder="Tên khách hàng, Nhà cung cấp" value={this.state.keyword} onChange={this.handleSearchChange.bind(this, "keyword")} />
                  </InputGroup>
                </Col>

                <Col sm="3" className="mb-2">
                  <InputGroup size="md">
                    <Input name="keyword" autoComplete="off" placeholder="Mã nhân viên KD" value={this.state.maNhanVien} onChange={this.handleSearchChange.bind(this, "maNhanVien")} />
                  </InputGroup>
                </Col>
                <Col sm="4" className="mb-2">
                <InputGroup size="md">
                     <CheckboxTreeList
                      placeholder={`--Chọn Kho--`}
                      nodes={listKhoXuat}
                      checked ={this.state.multipleValueKhoXuat}
                      isMultiChoice={true}
                      onHandleRemove={(item) => this.onHandleRemoveKhoXuat(item)}
                      onChoice={e => this.onHandleChoiceKhoXuat(e)}
                    />
                  </InputGroup>
                </Col>
              </Row>
            </Collapsible>
            <div className="w-100 mb-2 mt-2">
              <Button size="md" color="success" className="mr-1" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Thống kê</Button>&nbsp;
              <Button size="md" color="success" className="mr-1" onClick={this.exportXls.bind(this, {})}><i className="fa fa-file-excel-o"></i> Xuất excel</Button>
            </div>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="mb-0 d-sm-table table-sm table-bordered">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" rowSpan="2" className="text-center">Mã khách hàng</th>
                    <th scope="col" rowSpan="2" className="text-center">Tên khách hàng</th>
                    <th scope="col" rowSpan="2" className="text-center">Địa chỉ</th>
                    <th scope="col" colSpan="2" className="text-center">Đầu kỳ</th>
                    <th scope="col" colSpan="2" className="text-center">Phát sinh</th>
                    <th scope="col" colSpan="2" className="text-center">Cuối kỳ</th>
                  </tr>
                  <tr>
                    <th className="text-center">Nợ</th>
                    <th className="text-center">Có</th>
                    <th className="text-center">Nợ</th>
                    <th className="text-center">Có</th>
                    <th className="text-center">Nợ</th>
                    <th className="text-center">Có</th>
                  </tr>
                </thead>
                <tbody>
                {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                    <td> <a href='#' onClick={(e) => this.viewCongNoKh(e, res.Ma)}>{res.Ma}</a></td>
                    <td>{res.Ten}</td>
                    <td>{res.DiaChi}</td>
                    <td className="text-right">{parseFloat(res.NoDauKy || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                    <td className="text-right">{parseFloat(res.CoDauKy || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                    <td className="text-right">{parseFloat(res.NoPhatSinh || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                    <td className="text-right">{parseFloat(res.CoPhatSinh || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                    <td className="text-right">{parseFloat(res.NoCuoiKy || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                    <td className="text-right">{parseFloat(res.CoCuoiKy || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                    </tr>
                    ))
                  )}
                </tbody>
                <tfoot>
                  <tr>
                    <th scope="col" colSpan="3" className="text-right">
                      Tổng
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {this.state.total_record &&
                          this.state.total_record[0].t_NoDauKy.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })}</span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {this.state.total_record &&
                          this.state.total_record[0].t_CoDauKy.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })}</span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {this.state.total_record &&
                          this.state.total_record[0].t_NoPhatSinh.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })}</span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {this.state.total_record &&
                          this.state.total_record[0].t_CoPhatSinh.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })}</span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {this.state.total_record &&
                          this.state.total_record[0].t_NoCuoiKy.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })}</span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {this.state.total_record &&
                          this.state.total_record[0].t_CoCuoiKy.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })}</span>
                    </th>
                  </tr>
                </tfoot>
              </Table>
              {this.state.totalRecord > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  congNo: state.congNo,
  client: state.client,
})

const connected = connect(mapStateToProps, {
  congNoKhoXuatRequest: congNoAction.congNoKhoXuatRequest,
  congNoListRequest: congNoAction.congNoListRequest,
  reportExportXlsRequest: congNoAction.reportExportXlsRequest
})(CongNo)

const formed = reduxForm({
  form: 'congNo',
})(connected)

export default formed;




// WEBPACK FOOTER //
// ./src/views/CongNo/CongNo.js